import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/999games.webp';
import screenshot_target from '../../../images/letterfunnel/nielsjonker.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Niels Jonker"
      firstname="Niels"
      companyname="999 Games"
      competition="White Goblin Games en Asmodee"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/nielsjonker.js